import styled from 'styled-components/macro';

export const UpDownSwitchDiv = styled.div`
  display: inline-block;
  margin-left: 7px;
  position: relative;
  svg {
    display: block;
    width: 7.5px;
    height: 6.5px;
  }
`;
